export const saveFile = (content: string, fileName: string): void => {
  const a = document.createElement('a');
  const file = new Blob([content], { type: 'text/plain' });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
};

export const browseToAndLoadFile = (accept: string, callback: (data: string) => void): void => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;
  input.click();
  input.onchange = (): void => {
    const reader = new FileReader();
    reader.onload = (e): void => {
      if (!e?.target?.result) return;
      callback(e.target.result as string);
    };
    if (!input?.files?.[0]) {
      callback('');
      return;
    }
    reader.readAsText(input.files[0]);
  };
};

export const loadJSON = async (url: string): Promise<object | null> =>
  new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.overrideMimeType('application/json');
    xhr.open('GET', url, true);

    xhr.onreadystatechange = (): void => {
      if (xhr.readyState > 3 && xhr.status >= 200 && xhr.status < 300) {
        // success
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const data = JSON.parse(xhr.response) as object;
        resolve(data);
      } else if (xhr.status === 404) {
        // 404 error
        resolve(null);
      }
    };
    xhr.send(null);
  });
